import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_core/_services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss']
})
export class MainViewComponent implements OnInit {
  constructor(
    public authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  // Check if we're on the login page
  get isLoginPage(): boolean {
    return this.router.url === '/login';
  }

  // Check if navigation should be shown
  get shouldShowNavigation(): boolean {
    return !!this.authenticationService.userValue && !this.isLoginPage;
  }
}
